<template>
  <b-modal
    :active.sync="showModal"
    :width="450"
  >
    <div
      class="modal-card"
      style="width: auto"
    >
      <header class="modal-card-head is-block">
        <span class="icon-static xl large-preview" />
        <h4 class="title is-4">
          Download a Preview
        </h4>
      </header>
      <section class="modal-card-body text is-centered">
        <p>
          This track is watermarked by Sonata and should only be used for testing and previewing
          purposes. Using this in projects is not allowed.
        </p>
      </section>
      <footer class="modal-card-foot is-block">
        <a
          :href="$store.getters['common/previewDownloadUrl']"
          class="button is-fullwidth is-primary margin-bottom-sm is-large"
        >
          Download MP3
        </a>
        <button
          class="button is-fullwidth is-secondary is-large"
          @click.prevent="$store.dispatch('common/hidePreviewDownloadModal')"
        >
          Cancel
        </button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ThePreviewDownloadModal',

  computed: {
    showModal: {
      get: function () {
        return this.$store.getters['common/showPreviewDownloadModal']
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.dispatch('common/showPreviewDownloadModal')
        } else {
          this.$store.dispatch('common/hidePreviewDownloadModal')
        }
      }
    }
  }
}
</script>

<style>
</style>
